
import { createContext, useContext } from "react";

export const AuthContext = createContext();

const TOKEN_KEY = "session-token";
const MAIL_KEY = "login_mail";
const EXPIRY_KEY = "session-expiry";
const ONE_DAY_MS = 24 * 60 * 60 * 1000;
const GTOKEN_KEY = "google_auth_token";
const GEXPIRY_KEY = "googlesession-expiry";
const GONE_DAY_MS = 24 * 60 * 60 * 1000;
const SEC_KEY = "sec_key";

export const AuthProvider = ({ children }) => {
    
    const storeSecKey = (secKey) => {
        if (secKey && secKey !== "" && secKey !== "undefined" && secKey !== "null") {
            localStorage.setItem(SEC_KEY, secKey);
            console.log("✅ Security key stored:", secKey.substring(0, 15) + "...");
            return true;
        }
        return false;
    }

    const storeGooleAuthToken = (googleToken) => {
        if (googleToken && googleToken !== "" && googleToken !== "undefined") {
            const expiryTime = Date.now() + GONE_DAY_MS;
            localStorage.setItem(GTOKEN_KEY, googleToken);
            localStorage.setItem(GEXPIRY_KEY, expiryTime.toString());
            console.log("✅ Google token stored");
        }
    }

    const storeLoginToken = (loginToken) => {
        if (loginToken && loginToken !== "" && loginToken !== "undefined") {
            const expiryTime = Date.now() + ONE_DAY_MS;
            localStorage.setItem(TOKEN_KEY, loginToken);
            localStorage.setItem(EXPIRY_KEY, expiryTime.toString());
            console.log("✅ Login token stored");
        }
    }

    const storeLoginMail = (loginMail) => {
        if (loginMail) localStorage.setItem(MAIL_KEY, loginMail);
    }

    const getLoginToken = () => {
        const token = localStorage.getItem(TOKEN_KEY);
        const expiry = parseInt(localStorage.getItem(EXPIRY_KEY) || "0", 10);

        if (!token || !expiry || Date.now() > expiry) {
            localStorage.removeItem(TOKEN_KEY);
            localStorage.removeItem(EXPIRY_KEY);
            return null;
        }
        return token;
    }

    const getSecKey = () => {
        const secKey = localStorage.getItem(SEC_KEY);
        if (secKey && secKey !== "undefined" && secKey !== "null" && secKey.length > 10) {
            return secKey;
        }
        return null;
    }

    const getBothToken = () => {
        const token = localStorage.getItem(TOKEN_KEY);
        const expiry = parseInt(localStorage.getItem(EXPIRY_KEY) || "0", 10);
        const copytoken = localStorage.getItem("session-token-copy");

        if (!token || !expiry || Date.now() > expiry) {
            localStorage.removeItem(TOKEN_KEY);
            localStorage.removeItem(EXPIRY_KEY);
            return null;
        }
        return { token, copytoken }
    }

    const getLoginMail = () => {
        return localStorage.getItem(MAIL_KEY);
    }

    const getGoogleAuthToken = () => {
        const token = localStorage.getItem(GTOKEN_KEY);
        const expiry = parseInt(localStorage.getItem(GEXPIRY_KEY) || "0", 10);

        if (!token || !expiry || Date.now() > expiry) {
            localStorage.removeItem(GTOKEN_KEY);
            localStorage.removeItem(GEXPIRY_KEY);
            return null;
        }
        return token;
    };

    return (
        <AuthContext.Provider value={{
            storeLoginToken,
            getLoginToken,
            storeLoginMail,
            getLoginMail,
            storeSecKey,
            getSecKey,
            storeGooleAuthToken,
            getGoogleAuthToken,
            getBothToken,
        }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const authContextValue = useContext(AuthContext);
    if (!authContextValue) {
        throw new Error("useAuth used outside of the Provider");
    }
    return authContextValue;
};